import authApi from '@api/authApi';
import { t } from '@i18n';
import { Card, Text } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { handleError } from '@util/errors';
import { useEffect } from 'react';

export const Route = createFileRoute('/_public/verify-email/$token')({
  component: VerifyEmail,
});

function VerifyEmail() {
  const { token } = Route.useParams();
  const navigate = useNavigate();

  useEffect(() => {
    let canceled = false;

    void (async () => {
      const ok = await handleError(() => authApi.verify(token));
      if (!ok || canceled) {
        return;
      }

      notifications.show({
        message: t('verifyEmail.done'),
      });

      void navigate({ to: '/' });
    })();

    return () => {
      canceled = true;
    };
  }, [token, navigate]);

  return (
    <Card
      withBorder
      shadow="md"
      css={{
        display: 'grid',
        gap: '1rem',

        '.validated & input:invalid': {
          borderColor: 'var(--mantine-color-red-6)',
        },
      }}
    >
      <h2>{t('verifyEmail.title')}</h2>
      <Text>{t('verifyEmail.message')}</Text>
    </Card>
  );
}
